(() => {
  const pop = document.querySelector('[data-sales-pop]');
  const items = [...document.querySelectorAll('[data-sales-pop-item]')];
  if (!pop || !items.length) return;

  for (let index = items.length - 1; index > 0; index -= 1) {
    const randomIndex = Math.floor(Math.random() * (index + 1));
    [items[index], items[randomIndex]] = [items[randomIndex], items[index]];
  }

  const lastTitle = sessionStorage.getItem('meru_sales_pop_last');
  if (items.length > 1 && items[0].dataset.title === lastTitle) {
    [items[0], items[1]] = [items[1], items[0]];
  }

  const link = pop.querySelector('[data-sales-pop-link]');
  const image = pop.querySelector('[data-sales-pop-image]');
  const location = pop.querySelector('[data-sales-pop-location]');
  const title = pop.querySelector('[data-sales-pop-title]');
  const time = pop.querySelector('[data-sales-pop-time]');
  let shown = 0;
  let dismissed = false;

  const hide = () => pop.classList.remove('is-visible');
  const show = () => {
    if (dismissed) return;
    const item = items[shown % items.length].dataset;
    link.href = item.url;
    image.src = item.image;
    image.alt = item.title;
    location.textContent = item.location;
    title.textContent = item.title;
    time.textContent = item.time;
    sessionStorage.setItem('meru_sales_pop_last', item.title);
    pop.hidden = false;
    requestAnimationFrame(() => pop.classList.add('is-visible'));
    shown += 1;
    setTimeout(() => {
      hide();
      if (!dismissed && shown < Math.min(3, items.length)) setTimeout(show, 18000);
    }, 6000);
  };

  pop.querySelector('[data-sales-pop-close]').addEventListener('click', () => {
    dismissed = true;
    hide();
  });
  setTimeout(show, 8000);
})();
